import React from 'react';
import ErrorBoundaries from '../../../components/ErrorBoundaries';
import EinstellungenSeitenKopf from '../components';
import UserTable from './components/UserTable';

function UserPage() {
  return (
    <>
      <EinstellungenSeitenKopf title="Benutzer" />
      <ErrorBoundaries>
        <UserTable />
      </ErrorBoundaries>
    </>
  );
}

export default UserPage;
